<dynamic-form-v2
    *ngIf="!isLoading"
    entityType="mystery-box-content"
    [formName]="title"
    [(record)]="mysteryBoxContentRecord"
    [fields]="fields"
    [viewRoute]="viewRoute"
    [autopopulateEntity]="true"
    (getExistedRecord)="onRecordLoaded($event)"
>
</dynamic-form-v2>

